import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import type { MapNode } from "../map/CampaignMap";
import type { RosterEntry } from "../game/RunState";
import { CHAMPIONS, TIER_COLORS } from "../data/champions";
import { championIconUrl } from "../config/constants";
import { levelForXp } from "../units/UnitStats";
import { CombatScene } from "./CombatScene";

export class MinionPickScene implements Scene {
  private root: HTMLDivElement;

  constructor(private game: Game, private node: MapNode) {
    this.root = document.createElement("div");
    this.root.className = "reward-screen";
  }

  enter(): void {
    const state = this.game.runState;
    if (!state) return;

    const alive = state.roster.filter((e) => !(e.currentHp !== null && e.currentHp <= 0));

    if (alive.length === 1) {
      // Defer to avoid re-entrant transition (SceneManager drops nested calls)
      setTimeout(() => this.pick(alive[0].id), 0);
      return;
    }

    const title = document.createElement("div");
    title.className = "reward-title";
    title.textContent = "CHOOSE YOUR FIGHTER";
    this.root.appendChild(title);

    const sub = document.createElement("div");
    sub.style.cssText = "color:var(--text-dim);font-size:11px;letter-spacing:1px;margin-bottom:12px";
    sub.textContent = "Solo fight · winner earns double XP";
    this.root.appendChild(sub);

    const cards = document.createElement("div");
    cards.className = "slot-pick-cards";
    this.root.appendChild(cards);

    for (const entry of alive) {
      cards.appendChild(this.buildCard(entry));
    }

    this.game.sceneRoot.appendChild(this.root);
  }

  private buildCard(entry: RosterEntry): HTMLDivElement {
    const def = CHAMPIONS[entry.championId];
    const color = TIER_COLORS[def.tier];
    const level = levelForXp(entry.xp);

    const card = document.createElement("div");
    card.className = "slot-pick-card";
    card.style.setProperty("--tc", color);
    card.innerHTML = `
      <div class="slot-pick-icon" style="background-image:url('${championIconUrl(def.iconId)}')"></div>
      <div class="slot-pick-info">
        <div class="slot-pick-name" style="color:${color}">${def.displayName}</div>
        <div class="slot-pick-level">Lv ${level}</div>
        <div class="slot-pick-stats">HP ${def.baseHp} · AD ${def.baseAd} · Range ${def.range}</div>
      </div>
    `;
    card.addEventListener("click", () => this.pick(entry.id));
    return card;
  }

  private pick(rosterId: string): void {
    const state = this.game.runState;
    if (!state) return;
    state.combatFighterIds = [rosterId];
    this.game.sceneManager.transition(new CombatScene(this.game, this.node));
  }

  exit(): void { this.root.remove(); }
  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
